const instagramSVG = ({color, size}) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 14" id="Instagram--Streamline-Core"
                height={size} width={size}>
            <g id="instagram">
                <g id="Group 4546">
                    <path id="Vector" stroke={color} strokeLinecap="round" strokeLinejoin="round"
                          d="M10.3332 3.64404c-0.1381 0 -0.25 -0.11193 -0.25 -0.25s0.1119 -0.25 0.25 -0.25"
                          strokeWidth="1"></path>
                    <path id="Vector_2" stroke={color} strokeLinecap="round" strokeLinejoin="round"
                          d="M10.3332 3.64404c0.1381 0 0.25 -0.11193 0.25 -0.25s-0.1119 -0.25 -0.25 -0.25"
                          strokeWidth="1"></path>
                </g>
                <path id="Rectangle 2" stroke={color} strokeLinecap="round" strokeLinejoin="round"
                      d="M0.858276 3.43141c0 -1.42103 1.151974 -2.573012 2.573014 -2.573012h6.86141c1.421 0 2.573 1.151982 2.573 2.573012v6.86139c0 1.421 -1.152 2.573 -2.573 2.573H3.43129c-1.42104 0 -2.573014 -1.152 -2.573014 -2.573V3.43141Z"
                      strokeWidth="1"></path>
                <path id="Ellipse 11" stroke={color} strokeLinecap="round" strokeLinejoin="round"
                      d="M4.312 6.862a2.55 2.55 0 1 0 5.1 0 2.55 2.55 0 1 0 -5.1 0" strokeWidth="1"></path>
            </g>
        </svg>
    );
}

export default instagramSVG;